module.exports = __webpack_public_path__ + "img/fang-year2.dd8e302f.png";